export function parseUrl() {
  let location = window.location
  return {
    href: location.href,
    protocol: location.protocol,
    host: location.host,
    hostname: location.hostname,
    port: location.port,
    pathname: location.pathname,
    search: location.search,
    hash: location.hash
  }
}

export function getQueryString(urlStr) {
  let url = urlStr || window.location.href
  let idx = url.indexOf('?')
  if (idx != -1) {
    let queryStr = url.slice(idx + 1)
    let queryArr = queryStr.split('&')
    let queryObj = {}
    for (let i = 0; i < queryArr.length; i++) {
      let obj = queryArr[i].split('=')
      queryObj[obj[0]] = obj[1]
    }
    return queryObj
  } else {
    return null
  }
}

/**
 * query search 对象转字符串
 * @param {object} obj
 * @param {boolean} deleteEmpty 是否删除空值
 * @returns
 */
export function dataToString(obj, deleteEmpty = true) {
  const arr = []
  Object.entries(obj).forEach(([key, value]) => {
    if (deleteEmpty && !value && value !== 0) {
      return
    }
    arr.push(`${key}=${value}`)
  })
  return arr.join('&')
}
